import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";

export const MotorMake = ({ make }: { make?: string }) => {
  const { i18n } = useLingui();

  if (make == null || make === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.engineManufacturer",
    message: "Engine-manufacturer",
    comment: "Field for 'engine manufacturer' in boat ad specification",
  });
  return <FieldValuePair field={field} value={make} />;
};
